import axios from 'axios';

const client = axios.create();

client.defaults.baseURL = import.meta.env.VITE_APP_ENV === 'LOCAL' ? '/api' : import.meta.env.VITE_APP_API_URL;
client.defaults.withCredentials = true;

export default client;
